import {IFieldMeta} from 'entities/metadata';
import {IUserInfo} from 'store/slices/auth-slice/auth-slice-types';

const shouldRenderField = (field: IFieldMeta, user?: IUserInfo) => !(field?.renderOnCondition?.authorized && !user);

export const filterNonRenderableFields = (
    fields: IFieldMeta[], user?: IUserInfo,
): IFieldMeta[] => fields
    .map(field => {
        if (!shouldRenderField(field, user)) {
            field.nonRenderable = true;
        }
        return field;
    })
    .filter(field => !field.nonRenderable);
